import Header from '../components/Header';
import { Box, Center, HStack, Text } from '@chakra-ui/react';
import { ReactNode, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import heroVideo from '../assets/hero.mp4';
import Footer from '../components/Footer';

export default function MainLayout({ children }: { children: ReactNode }) {
  const location = useLocation();

  const isClaimPage = useMemo(() => location.pathname === '/', [location.pathname]);
  const isStakingPage = useMemo(() => location.pathname.includes('staking'), [location.pathname]);

  return (
    <Box bg="#942AA820" w="100%" h="100%" minH="100vh" position="relative" overflowY="auto">
      <Box position="fixed" zIndex="0" top="0" left="0" right="0" bottom="0" w="100%" h="100vh">
        <video
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(10px)',
          }}
          onError={(e) => console.error('Video error:', e)}
        />
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          zIndex="1"
          bgGradient="linear(to-b, #942AA820 45%, #942AA800 100%)"
        />
      </Box>

      <Box position="relative" zIndex="1">
        <Header />
        <Center w="100%">
          <HStack borderRadius="full" p="1" mb="4">
            <Link to="/">
              <Center
                borderBottom="1px solid"
                borderBottomColor={isClaimPage ? 'white' : 'transparent'}
                py="2"
                px="4"
              >
                <Text
                  fontSize="md"
                  fontWeight="semibold"
                  fontFamily="uniwars"
                  color={isClaimPage ? 'white' : 'whiteAlpha.600'}
                >
                  Claim
                </Text>
              </Center>
            </Link>
            <Link to="/staking">
              <Center
                borderBottom="1px solid"
                borderBottomColor={isStakingPage ? 'white' : 'transparent'}
                py="2"
                px="4"
              >
                <Text
                  fontSize="md"
                  fontWeight="semibold"
                  fontFamily="uniwars"
                  color={isStakingPage ? 'white' : 'whiteAlpha.600'}
                >
                  Staking
                </Text>
              </Center>
            </Link>
          </HStack>
        </Center>
        {children}
        <Footer />
      </Box>
    </Box>
  );
}
